"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var _Icon = _interopRequireDefault(require("./Icon"));

var _jsxRuntime = require("react/jsx-runtime");

function Todo(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "card todo",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "todo-content",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "information",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
          icon: props.icon
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "todo-text",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          children: props.message
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "information mt-3",
          children: props.creationDate ? (0, _momentTimezone.default)(props.creationDate).fromNow() : ' '
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "action-bar",
      children: props.children
    })]
  });
}

Todo.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  creationDate: _propTypes.default.string,
  icon: _propTypes.default.string.isRequired,
  message: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]).isRequired
};
var _default = Todo;
exports.default = _default;
//# sourceMappingURL=Todo.js.map